module.exports = __webpack_public_path__ + "img/c2 white.a0dac0ae.png";